import React from 'react';
import { Form, Input, Select, Button, DatePicker } from 'antd';
import './AddFournisseurForm.css'; // Ensure this is linked correctly
import { useNavigate } from 'react-router-dom'; // For navigation back
const { Option } = Select;

const AddFournisseurForm = ({ initialValues }) => {
    const navigate = useNavigate(); // Initialize navigation

    const onSubmit = (values) => {
      console.log('Submitted values:', values);
      // Handle form submission logic (e.g., save data to state or send to API)
  
      // After submission, navigate back to the fournisseurs list
      navigate('/vehicules');
    };
    const [vehicleForm] = Form.useForm();
    const vehicleTypes = ['Camion', 'Minibus'];
  return (
    <Form form={vehicleForm} layout="vertical" className="add-fournisseur-form">

        <div className="form">
            <Form.Item
                label="AJOUTER UN VEHICULE"
                className="form-item"
                
            >
                <Input placeholder="Rechercher un véhicule" className="input-field" />
            </Form.Item>
            <div className='form-row'>
                <Form.Item name="matricule" label="Immatriculation" rules={[{ required: true, message: 'Veuillez entrer l\'immatriculation' }]} className="form-item col-6">
                    <Input className="input-field" />
                </Form.Item>
                <Form.Item name="type" label="Type" rules={[{ required: true, message: 'Veuillez sélectionner le type' }]} className="form-item col-6">
                    <Select>
                        {vehicleTypes.map(type => (
                        <Option key={type} value={type}>{type}</Option>
                        ))}
                    </Select>
                </Form.Item>
            </div>
            <div className="form-row">
                <Form.Item name="vidageExpiry" label="Date d'expiration du vidage" className="form-item col-6" >
                    <DatePicker format="YYYY-MM-DD" />
                </Form.Item>
                <Form.Item name="insuranceExpiry" label="Date d'expiration de l'assurance" className="form-item col-6">
                    <DatePicker format="YYYY-MM-DD" />
                </Form.Item>
            </div>
            <Form.Item className="button-group">
        <div className="form-row ">
            <Button
            type="primary"
            htmlType="submit"
            className="submit-button"
            >
            {initialValues ? 'Modifier la ligne' : 'Ajouter véhicule'}
            </Button>
            <Button
            className="cancel-button"
            onClick={() => navigate('/vehicules')}
            >
            Annuler
            </Button>
            </div>
        </Form.Item>
        </div>
        
    
    
   
  </Form>
  );
};

export default AddFournisseurForm;
